var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.nama))])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.id_artikel != null ? 'Edit' : 'Tambah') + " " + _vm._s(_vm.nama))])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "id": "judul",
      "type": "text"
    },
    model: {
      value: (_vm.data.judul),
      callback: function($$v) {
        _vm.$set(_vm.data, "judul", $$v)
      },
      expression: "data.judul"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "id": "penulis",
      "type": "text"
    },
    model: {
      value: (_vm.data.penulis),
      callback: function($$v) {
        _vm.$set(_vm.data, "penulis", $$v)
      },
      expression: "data.penulis"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-line"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.kategori),
      expression: "data.kategori"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "kategori", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- Pilih Kategori --")]), _vm._v(" "), _vm._l((_vm.categories), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.category
      }
    }, [_vm._v("\n                          " + _vm._s(item.category) + "\n                        ")])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('Ckeditor', {
    ref: "ckeditor",
    attrs: {
      "id": "artikel",
      "config": _vm.config
    },
    model: {
      value: (_vm.data.content),
      callback: function($$v) {
        _vm.$set(_vm.data, "content", $$v)
      },
      expression: "data.content"
    }
  })], 1)])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-dropzone', {
    ref: "dropzoneThumnail",
    attrs: {
      "id": "dropzone-thumbnail",
      "destroyDropzone": false,
      "options": _vm.dropzoneOptionsThumnail
    },
    on: {
      "vdropzone-removed-file": _vm.vremoved,
      "vdropzone-success": _vm.onUploadSuccess
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (true) ? _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-dropzone', {
    ref: "dropzonePenulis",
    attrs: {
      "id": "dropzone-penulis",
      "destroyDropzone": false,
      "options": _vm.dropzoneOptionsPenulis
    },
    on: {
      "vdropzone-removed-file": _vm.vremoved,
      "vdropzone-success": _vm.onUploadSuccess
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [(_vm.id_artikel != null) ? _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-warning waves-effect waves-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.update
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), (!_vm.isLoading) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]) : _vm._e(), _vm._v(" Edit\n                  ")]) : _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-primary waves-effect waves-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), (!_vm.isLoading) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]) : _vm._e(), _vm._v("\n                    Simpan\n                  ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Batal\n                  ")])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "judul"
    }
  }, [_vm._v("Judul")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "penulis"
    }
  }, [_vm._v("Penulis")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "kategori"
    }
  }, [_vm._v("Kategori")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "artikel"
    }
  }, [_vm._v("Artikel")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "artikel"
    }
  }, [_vm._v("Foto Thumbnail Artikel")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "artikel"
    }
  }, [_vm._v("Foto Penulis Artikel")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2f937b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Informasi/Artikel/Artikel.vue
// module id = ccaf
// module chunks = 1